/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ScopeInputs */

const en_common_scope = /** @type {(inputs: Common_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

const es_common_scope = /** @type {(inputs: Common_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcance`)
};

/**
* | output |
* | --- |
* | "Scope" |
*
* @param {Common_ScopeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_scope = /** @type {((inputs?: Common_ScopeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ScopeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_scope(inputs)
	return en_common_scope(inputs)
});